import React, { useEffect, useState } from 'react';
import { PageType } from './interfaces/types';
import Navigation from './Navigation';
import IntroPage from './pages/Intro';
import ManifestoPage from './pages/Manifesto';
import ManifestoListPage from './pages/ManifestoList';
import MyBenefitPage from './pages/MyBenefit';
import ResultPage from './pages/Result';
import SurveyPage from './pages/Survey';

import APIKEY from './APIKEY';
import Debugger from './Debugger';
import ManifestoList from './pages/ManifestoList';
export interface AppState {
  dataLoaded: boolean;
  data: string[][];
}

function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('DEFAULT');

  const [state, setState] = useState<AppState>({
    dataLoaded: false,
    data: [],
  })

  const travelPageTo = (page: PageType, pathname = '') => {
    window.history.pushState(null, '', `/${page.toLowerCase()}/${pathname}`);
    setCurrentPage(page);
  }

  const loadData = async () => {
    // const sheetID = '1UU044EnUX2oKAwazNT7GnnEt_W-5TDiMCrP59JUJtRk'
    const sheetID = '1nXlgOnynMBAwjz8Onun_Ozd6CtHCLFvwChfPYf0haos'
    const res = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/production?key=${APIKEY}`, { method: 'GET' });
    const data = await res.json();

    console.log(data);

    setState({
      dataLoaded: true,
      data: data.values,
    })
  }

  useEffect(() => {
    const pathname = window.location.pathname;
    const mode = pathname.split('/')[1];
    const tag = pathname.split('/')[2];
    if (!mode) {
      travelPageTo('INTRO');
    }
    else {
      travelPageTo(mode.toUpperCase() as PageType, tag)
    }
  })


  return (
    <div className="App">
      {/* <Debugger
        setCurrentPage={travelPageTo}
      /> */}
      <Navigation
        setCurrentPage={travelPageTo}
      />
      {
        {
          DEFAULT: <></>,
          INTRO: <IntroPage setCurrentPage={travelPageTo}/>,
          SURVEY: <SurveyPage setCurrentPage={travelPageTo} onSubmitHook={loadData}/>,
          RESULT: <ResultPage setCurrentPage={travelPageTo} loadData={loadData} state={state}/>,
          MANIFESTO: <ManifestoPage />,
          MANIFESTOLIST: <ManifestoListPage setCurrentPage={travelPageTo}/>,
          MYBENEFIT: <MyBenefitPage setCurrentPage={travelPageTo} loadData={loadData} state={state} />,
        }[currentPage]
      }
    </div>
  );
}

export default App;
